import { createCommandHook } from '@one-snap/core';
import { useCallback } from 'react';
import { useGetContactInformation } from '../hook/useGetContactInformation';
import { ErrorType } from './types';

export const useGetContactInformationCommand = createCommandHook(() => {
  const { getContactInformation, getContactInformationLoading } =
    useGetContactInformation();

  const execute = useCallback(async () => {
    const response = await getContactInformation();
    const errors = !response.success ? [ErrorType.GET_ERROR] : [];
    return {
      errors,
      data: response.data
    };
  }, [getContactInformation]);

  return {
    execute,
    executing: getContactInformationLoading
  };
});
